import dayjs from 'dayjs';

export const endOfDay = (date: Date): Date => {
  return dayjs(date).endOf('day').toDate();
};
